// app/frontend/fileUpload.js
import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import AwsS3 from '@uppy/aws-s3'
import AwsS3Multipart from '@uppy/aws-s3-multipart'
import Webcam from '@uppy/webcam'
import Audio from '@uppy/audio'

import { getOperatingSystem } from './utils/getUserOS';

function fileUpload(fileInput,greetLocale) {
  const hiddenInput = document.querySelector('.upload-data'),
        formGroup = fileInput.parentNode;

  // remove our file input in favour of Uppy's
  formGroup.removeChild(fileInput);

  const os = getOperatingSystem();
  let plugins = null
  if (os == 'Desktop/Laptop') {
    plugins = ['Webcam','Audio']
  } else if (os == 'Android') {
    plugins = ['Audio']
  }

  const t = {
    en: {
      d: {
        heading: "Drag and drop files here or choose one of the following options to record or upload your message:",
        browse: "SELECT FROM COMPUTER",
        myDevice: "Upload",
        done: "Cancel",
        cancel: "Cancel",
        record: "Record",
        success: "Uploaded the video successfully",
        allowAccessDescription: 'In order to take pictures or record video with your camera, please allow camera access for this site.',
        allowAccessTitle: 'Please allow access to your camera',
        allowAudioAccessDescription: 'In order to record audio, please allow microphone access for this site.',
        allowAudioAccessTitle: 'Please allow access to your microphone',
        import: 'Import',
        importFrom: 'Import from %{name}',
        startRecording: 'Begin video recording',
        stopRecording: 'Stop video recording',
        submitRecordedFile: 'Submit recorded file'
      },
      m: {
        heading: "",
        browse: "CAMERA OR LIBRARY",
        myDevice: "Camera or Library"
      }
    },
    es: {
      d: {
        heading: "Arrastre y suelte archivos aquí o elija una de las siguientes opciones para grabar o cargar su mensaje:",
        browse: "SELECCIONAR DESDE LA COMPUTADORA",
        myDevice: "Subir",
        done: "Cancelar",
        cancel: 'Cancelar',
        record: "Record",
        success: "Subí el video con éxito",
        allowAccessDescription: 'Para tomar fotos o grabar video con tu cámara, por favor permite a este sitio el acceso a la cámara.',
        allowAccessTitle: 'Por favor permite el acceso a tu cámara',
        authenticateWith: 'Conectar a %{pluginName}',
        authenticateWithTitle: 'Por favor autentícate con %{pluginName} para seleccionar archivos',
        import: 'Importar',
        importFrom: 'Importar desde %{name}',
        startRecording: 'Comenzar la grabación de video',
        stopRecording: 'Detener la grabación de video',
        submitRecordedFile: 'Enviar archivo grabado'
      },
      m: {
        heading: "",
        browse: "CÁMARA O BIBLIOTECA",
        myDevice: "Cámara o Archivos"
      }
    },
    fr: {
      d: {
        heading: "Faites glisser et déposez des fichiers ici ou choisissez l'une des options suivantes pour enregistrer ou télécharger votre message:",
        browse: "SÉLECTIONNER DE L'ORDINATEUR",
        myDevice: "Télécharger",
        done: "Annuler",
        cancel: 'Annuler',
        record: "Record",
        success: "Téléversé la vidéo avec succès",
        allowAccessDescription: 'Pour prendre des photos ou enregistrer une vidéo avec votre caméra, veuillez autoriser l\'accès à votre caméra pour ce site.',
        allowAccessTitle: 'Veuillez autoriser l\'accès à votre caméra',
        authAborted: 'Authentification interrompue',
        authenticateWith: 'Se connecter à %{pluginName}',
        authenticateWithTitle: 'Veuillez vous authentifier avec %{pluginName} pour sélectionner les fichiers',
        import: 'Importer',
        importFrom: 'Importer de %{name}',
        smile: 'Souriez !',
        startRecording: 'Commencer l\'enregistrement vidéo',
        stopRecording: 'Arrêter l\'enregistrement vidéo',
        submitRecordedFile: 'Envoyer la vidéo enregistrée'
      },
      m: {
        heading: "",
        browse: "CAMÉRA OU BIBLIOTHÈQUE",
        myDevice: "Appareil photo ou Fichiers"
      }
    },
    de: {
      d: {
        heading: "Ziehen Sie Dateien hierher und legen Sie sie dort ab oder wählen Sie eine der folgenden Optionen, um Ihre Nachricht aufzuzeichnen oder hochzuladen:",
        browse: "VOM COMPUTER AUSWÄHLEN",
        myDevice: "Hochladen",
        done: "Absagen",
        cancel: "Absagen",
        record: "Aufzeichnung",
        success: "Video erfolgreich hochgeladen",
        allowAccessDescription: 'Um Fotos oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie bitte den Kamerazugriff für diese Website.',
        allowAccessTitle: 'Bitte erlauben Sie den Zugriff auf Ihre Kamera',
        allowAudioAccessDescription: 'Um Audio aufzunehmen, erlauben Sie bitte den Mikrofonzugriff für diese Seite.',
        allowAudioAccessTitle: 'Bitte erlauben Sie den Zugriff auf Ihr Mikrofon',
        import: 'Importieren',
        importFrom: 'Importieren von %{name}',
        startRecording: 'Beginnen Sie mit der Videoaufnahme',
        stopRecording: 'Stoppen Sie die Videoaufnahme',
        submitRecordedFile: 'Aufgenommene Datei senden'
      },
      m: {
        heading: "",
        browse: "KAMERA ODER BIBLIOTHEK",
        myDevice: "Kamera oder Dateien"
      }
    },
    it: {
      d: {
        heading: "Trascina e rilascia i file qui o scegli una delle seguenti opzioni per registrare o caricare il tuo messaggio:",
        browse: "SELEZIONA DA COMPUTER",
        myDevice: "Carica",
        done: "Annulla",
        cancel: "Annulla",
        record: "Registra",
        success: "Caricato il video con successo",
        allowAccessDescription: "Per scattare foto o registrare video con la tua fotocamera, permetti l'accesso alla fotocamera per questo sito.",
        allowAccessTitle: "Per favore, permetti l'accesso alla tua fotocamera",
        allowAudioAccessDescription: "Per registrare audio, permetti l'accesso al microfono per questo sito.",
        allowAudioAccessTitle: "Per favore, permetti l'accesso al tuo microfono",
        import: "Importa",
        importFrom: "Importa da %{name}",
        startRecording: "Inizia registrazione video",
        stopRecording: "Interrompi registrazione video",
        submitRecordedFile: "Invia file registrato"
      },
      m: {
        heading: "",
        browse: "FOTOCAMERA O LIBRERIA",
        myDevice: "Fotocamera o Libreria",
      }
    },
    ro: {
      d: {
        heading: "Trageți și plasați fișiere aici sau alegeți una dintre următoarele opțiuni pentru a vă înregistra sau încărca mesajul:",
        browse: "SELECTARE DE LA COMPUTER",
        myDevice: "Încărcați",
        done: "Anulare",
        cancel: "Anulare",
        record: "Record",
        success: "Videoclipul a fost încărcat cu succes",
        allowAccessDescription: 'Pentru a face fotografii sau a înregistra videoclipuri cu camera dvs., vă rugăm să permiteți accesul camerei pentru acest site.',
        allowAccessTitle: 'Vă rugăm să permiteți accesul la camera dvs',
        allowAudioAccessDescription: 'Pentru a înregistra audio, vă rugăm să permiteți accesul la microfon pentru acest site.',
        allowAudioAccessTitle: 'Vă rugăm să permiteți accesul la microfon',
        import: 'Import',
        importFrom: 'Importat din %{name}',
        startRecording: 'Începeți înregistrarea video',
        stopRecording: 'Opriți înregistrarea video',
        submitRecordedFile: 'Trimiteți fișierul înregistrat'
      },
      m: {
        heading: "",
        browse: "CAMERA SAU BIBLIOTECA",
        myDevice: "Cameră sau Fișiere"
      }
    },
    pt: {
      d: {
        heading: "Arraste e solte arquivos aqui ou escolha uma das seguintes opções para gravar ou carregar sua mensagem:",
        browse: "SELECIONE DO COMPUTADOR",
        myDevice: "Envio",
        done: "Cancelar",
        cancel: "Cancelar",
        record: "Registro",
        success: "Carregado o vídeo com sucesso",
        allowAccessDescription: 'Para tirar fotos ou gravar vídeos com sua câmera, permita o acesso da câmera a este site.',
        allowAccessTitle: 'Por favor, permita o acesso à sua câmera',
        allowAudioAccessDescription: 'Para gravar áudio, permita o acesso ao microfone para este site.',
        allowAudioAccessTitle: 'Por favor, permita o acesso ao seu microfone',
        import: 'Importar',
        importFrom: 'Importado de %{name}',
        startRecording: 'Iniciar a gravação de vídeo',
        stopRecording: 'parar a gravação de vídeo',
        submitRecordedFile: 'Enviar arquivo gravado'
      },
      m: { 
        heading: "",
        browse: "CÂMERA OU BIBLIOTECA",
        myDevice: "Câmera ou arquivos"
      }
    },
    nb: {
      d: {
        heading: "Dra og slipp filer her eller velg en av følgende alternativer for å spille inn eller laste opp meldingen din:",
        browse: "VELG FRA DATAMASKIN",
        myDevice: "Last opp",
        done: "Avbryt",
        cancel: "Avbryt",
        record: "Spill inn",
        success: "Videoen ble lastet opp vellykket",
        allowAccessDescription: 'For å ta bilder eller spille inn video med kameraet ditt, må du gi tilgang til kameraet for dette nettstedet.',
        allowAccessTitle: 'Vennligst gi tilgang til kameraet ditt',
        allowAudioAccessDescription: 'For å spille inn lyd, må du gi tilgang til mikrofonen for dette nettstedet.',
        allowAudioAccessTitle: 'Vennligst gi tilgang til mikrofonen din',
        import: 'Importer',
        importFrom: 'Importer fra %{name}',
        startRecording: 'Start videoopptak',
        stopRecording: 'Stopp videoopptak',
        submitRecordedFile: 'Send inn opptaksfil'
      },
      m: {
        heading: "",
        browse: "KAMERA ELLER BIBLIOTEK",
        myDevice: "Kamera eller bibliotek"
      }   
    },
    nn: {
      d: {
        heading: "Dra og slepp filer her eller velg eitt av følgjande alternativ for å spela inn eller lasta opp bodet ditt:",
        browse: "VEL FRÅ DATAMASKIN",
        myDevice: "Last opp",
        done: "Avbryt",
        cancel: "Avbryt",
        record: "Spela inn",
        success: "Videoen vart lasta opp lukkeleg",
        allowAccessDescription: 'For å ta bilete eller spela inn video med kameraet ditt, må du gi tilgang til kameraet for denne nettstaden.',
        allowAccessTitle: 'Ver venleg og gi tilgang til kameraet ditt',
        allowAudioAccessDescription: 'For å spela inn lyd, må du gi tilgang til mikrofonen for denne nettstaden.',
        allowAudioAccessTitle: 'Ver venleg og gi tilgang til mikrofonen din',
        import: 'Importer',
        importFrom: 'Importer frå %{name}',
        startRecording: 'Start videoopptak',
        stopRecording: 'Stopp videoopptak',
        submitRecordedFile: 'Send inn opptaksfila'
      },
      m: {
        heading: "",
        browse: "KAMERA ELLER BIBLIOTEK",
        myDevice: "Kamera eller bibliotek"
      }    
    },
    no: {
      d: {
        heading: "Dra og slipp filer her eller velg en av følgende alternativer for å spille inn eller laste opp meldingen din:",
        browse: "VELG FRA DATAMASKIN",
        myDevice: "Last opp",
        done: "Avbryt",
        cancel: "Avbryt",
        record: "Spill inn",
        success: "Videoen ble lastet opp vellykket",
        allowAccessDescription: 'For å ta bilder eller spille inn video med kameraet ditt, må du gi tilgang til kameraet for dette nettstedet.',
        allowAccessTitle: 'Vennligst gi tilgang til kameraet ditt',
        allowAudioAccessDescription: 'For å spille inn lyd, må du gi tilgang til mikrofonen for dette nettstedet.',
        allowAudioAccessTitle: 'Vennligst gi tilgang til mikrofonen din',
        import: 'Importer',
        importFrom: 'Importer fra %{name}',
        startRecording: 'Start videoopptak',
        stopRecording: 'Stopp videoopptak',
        submitRecordedFile: 'Send inn opptaksfil'
      },
      m: {
        heading: "",
        browse: "KAMERA ELLER BIBLIOTEK",
        myDevice: "Kamera eller bibliotek"
      }
    },
  };

  // Get text block or default to english
  const text = t[greetLocale] ? t[greetLocale] : t['en'];

  const uppy = new Uppy({
    autoProceed: true,
    restrictions: {
      allowedFileTypes: fileInput.accept.split(','),
      maxNumberOfFiles: 1
    },
    locale: {
      strings: {
        myDevice: os == 'Desktop/Laptop' ? text.d.myDevice : text.m.myDevice,
        done: text.d.done,
        cancel: text.d.cancel,
        // Used as the label for the link that opens the system file selection dialog.
        browse: os == 'Desktop/Laptop' ? text.d.browse : text.m.browse,
        // Text to show on the droppable area.
        dropPasteBoth: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteFiles: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteFolders: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteBoth: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteImportFiles: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteImportFolders: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteImportBoth: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropHint: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropHereOr: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPaste: os == 'Desktop/Laptop' ? text.d.heading : '%{browse}',
        dropPasteImport: os == 'Desktop/Laptop' ? text.d.heading :'%{browse}',

        allowAccessDescription: text.d.allowAccessDescription,
        allowAccessTitle: text.d.allowAccessTitle,
        allowAudioAccessDescription: text.d.allowAudioAccessDescription,
        allowAudioAccessTitle: text.d.allowAudioAccessTitle,
        import: text.d.import,
        importFrom: text.d.importFrom,
        startRecording: text.d.startRecording,
        stopRecording: text.d.stopRecording,
        submitRecordedFile: text.d.submitRecordedFile,
      },    
    },
  })
  .use(Dashboard, {
    plugins: plugins,
    inline: true,
    target: formGroup,
    showProgressDetails: true,
    proudlyDisplayPoweredByUppy: false,
    browserBackButtonClose: false,
    doneButtonHandler: null,
    theme: 'auto',
  })
  

  // Use Webcam for desktop
  if(os == 'Desktop/Laptop'){
    uppy.use(Webcam, { 
      target: Dashboard,
      modes: [
        'video-audio',
      ],
      mirror: true,
      videoConstraints: {
        facingMode: "user",
        width: { min: 720, ideal: 1280, max: 1920 },
        height: { min: 480, ideal: 800, max: 1080 },
      },
      showRecordingLength: true,
      showVideoSourceDropdown: true,
      preferredVideoMimeType: 'video/mp4',
      title: text.d.record
    })
  }
  // Use Audio for desktop or android
  // if(os == 'Desktop/Laptop' || os == 'Android'){
  uppy.use(Audio, {
    target: Dashboard,
    showAudioSourceDropdown: true,
  })
  // }

  if (fileInput.dataset.uploadServer == 's3') {
    uppy.use(AwsS3, {
      companionUrl: '/', // will call Shrine's presign endpoint mounted on `/s3/params`
    });
  } else if (fileInput.dataset.uploadServer == 's3_multipart') {
    uppy.use(AwsS3Multipart, {
      companionUrl: '/' // will call uppy-s3_multipart endpoint mounted on `/s3/multipart`
    });
  }

  uppy.on('upload-success', (file, response) => {

    let id;
    if (fileInput.dataset.uploadServer == 's3') {
      id = file.meta['key'].match(/^uploads\/(.+)/)[1]; // object key without prefix
    } else if (fileInput.dataset.uploadServer == 's3_multipart') {
      id = response.uploadURL.match(/\/uploads\/([^\?]+)/)[1]; // object key without prefix
    }

    // construct uploaded file data in the format that Shrine expects
    const uploadedFileData = {
      id, // object key without prefix
      storage: 'uploads',
      uploadURL: response.uploadURL,
      metadata: {
        size: file.size,
        filename: file.name,
        mime_type: file.type,
      }
    };
    
    hiddenInput.value = JSON.stringify(uploadedFileData);

    document.getElementById('uppy-widget-form').submit();

  })

  formGroup.onsubmit = () => uppy.info(text.d.success);
}

export { fileUpload };
